import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { useEvergreenCountdown } from "../../..//hooks/useEvergreenCountdown";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "What is Kundli Matching?",
      answer: "Kundli Matching is the process of comparing two birth charts to check compatibility for marriage."
    },
    {
      question: "Why is Kundli Matching important for marriage?",
      answer: "It helps predict harmony, emotional balance, health, and stability in married life."
    },
    {
      question: "How is Kundli Matching done?",
      answer: "It uses methods like Ashtakoot and Dashakoot, which compare birth details such as date, time, and place."
    },
    {
      question: "What is Guna Milan in Kundli Matching?",
      answer: "Guna Milan scores compatibility on 36 points. A higher score shows better match."
    },
    {
      question: "What are Doshas in Kundli Matching?",
      answer: "Doshas are planetary imbalances that can cause problems in health, relationships, or delays in marriage."
    },
    {
      question: "Can Doshas be corrected?",
      answer: "Yes. Remedies like mantras, poojas, gemstones, or guidance from an astrologer can reduce their effects."
    },
    {
      question: "What details are needed for a Kundli Matching report?",
      answer: "You need the full name, date of birth, time of birth, and place of birth of both partners."
    },
    {
      question: "Can Kundli Matching be done online?",
      answer: "Yes. Online tools can generate quick and accurate reports within minutes."
    },
    {
      question: "Is Kundli Matching only about astrology?",
      answer: "No. Some systems also use numerology and name matching for deeper analysis."
    },
    {
      question: "What if the Guna score is low?",
      answer: "A low score does not always mean marriage is impossible. Remedies and guidance can balance it."
    },
    {
      question: "Is Kundli Matching 100% accurate?",
      answer: "It is based on Vedic astrology, which is a time-tested method. Still, personal choice and effort also matter in marriage."
    },
    {
      question: "Can I consult an astrologer after getting the report?",
      answer: "Yes. For personalized advice, you can book a one-on-one session with a qualified astrologer."
    }
  ];

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [hideFooter, setHideFooter] = useState(false);

  useEffect(() => {
    const section = document.getElementById("pricing-section");
    if (!section) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setHideFooter(entry.isIntersecting); // true => hide, false => show
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  const { display } = useEvergreenCountdown("lifeReportOfferEnd", 4 * 60 * 60 * 1000);


  return (
    <section className="pt-20 pb-[120px] bg-gradient-to-b from-background_km to-muted_km">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground_km mb-4">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-orange-100 rounded-lg border border-orange-200 px-6"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-800 hover:text-primary_km">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>

      {/* Countdown Timer */}
      <div className={`fixed inset-x-0 bottom-0 z-50  bg-gradient-to-b from-cosmic-gold to-cosmic-glow border-t border-cosmic-gold/40 shadow-2xl pb-[env(safe-area-inset-bottom)] transition-transform duration-300 md:block ${hideFooter ? "translate-y-full" : "translate-y-0"
        } md:translate-y-0`}>
        <div className="mx-auto w-full max-w-screen-xl px-3 sm:px-6 py-2 sm:py-3">
          <div className="flex flex-col sm:flex-row items-center sm:justify-center gap-2 sm:gap-6">

            {/* Price (show only final price on mobile) */}
            <div className="text-primary-foreground text-center sm:text-left leading-none">
              <span className="inline-block text-sm sm:text-base line-through opacity-80 px-2">₹1996</span>
              <span className="inline-block text-xl sm:text-3xl font-bold sm:ml-2">₹1050</span>
            </div>

            {/* Button */}
            <Button
              onClick={handleScrollToPricing}
              variant="secondary"
              className="w-full sm:w-auto h-10 sm:h-12 px-4 sm:px-6 text-sm sm:text-base bg-primary_km text-cosmic-gold hover:bg-cosmic-blue-light"
            >
              GET YOUR REPORT NOW
            </Button>

            <div className="text-primary-foreground text-center sm:text-left leading-none">
              <span className="text-sm">Offer ends soon in:</span>
              <div className="text-base sm:text-2xl font-bold tabular-nums">{display}</div>
            </div>

          </div>
        </div>
      </div>

    </section>
  );
};

export default FAQ;